import React, { Suspense, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { HashRouter, Route, Routes, Navigate } from 'react-router-dom'
import { updateShowSideBar } from './redux/auth/authSlice'

import { useTranslation } from 'react-i18next'

// Global Styles from styled-components
import {
  GlobalStyles,
  ReactConfirmAlertStyles,
  ToastContainerStyles,
  RechartsStyles,
  CustomSortIconStyles,
} from './styles/custom-scius.index'

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
const ForgotPassword = React.lazy(() => import('./views/pages/forgotPassword/Forgotpassword'))
// const Register = React.lazy(() => import('./views/pages/register/Register'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))
const PasswordReset = React.lazy(() => import('./views/pages/forgotPassword/PasswordReset'))

const AdminSelectCompany = React.lazy(() => import('./views/pages/login/SelectCompany'))

const App = () => {
  const { i18n } = useTranslation()
  const dispatch = useDispatch()
  const { isLoggedIn, isTokenVerified, token, company } = useSelector(
    (state) => state.authReducer.user,
  )
  useEffect(() => {
    i18n.changeLanguage('pt_BR')
  }, [i18n])

  useEffect(() => {
    const subdominio = window.location.hostname.split('.')[0]
    // TODO:: check scius domain
    if (subdominio !== 'localhost') {
      import(`./scss/style-scius.scss`)
        .then(() => console.log(`Estilo para ${subdominio} carregado`))
        .catch(() => console.error(`Estilo para ${subdominio} não encontrado`))
    } else {
      import(`./scss/style-scius.scss`)
        .then(() => console.log(`Estilo para ${subdominio} carregado`))
        .catch(() => console.error(`Estilo para ${subdominio} não encontrado`))
    }
    Notification.requestPermission().then((permission) => {
      if (permission === 'granted') {
        console.log('Notification permission granted.')
      }
    })
  }, [])

  //screen size validation
  useEffect(() => {
    const isMobile = window.innerWidth <= 780
    if (isMobile) {
      dispatch(updateShowSideBar(false))
    }
  })

  // Função para determinar se deve mostrar login ou dashboard
  const shouldShowLogin = () => {
    return !isLoggedIn || !isTokenVerified
  }

  return (
    <HashRouter>
      <GlobalStyles />
      <ReactConfirmAlertStyles />
      <ToastContainerStyles />
      <RechartsStyles />
      <CustomSortIconStyles />
      <Suspense fallback={loading}>
        <Routes>
          {['/', 'login'].map((path, index) => (
            <Route
              exact
              path={path}
              name="Login Page"
              key={index}
              element={shouldShowLogin() ? <Login /> : <Navigate to="/agentes" replace />}
            />
          ))}
          <Route exact path="/forgot" name="Forgot Password" element={<ForgotPassword />} />
          <Route exact path="/password-reset" name="Forgot Password" element={<PasswordReset />} />
          {/* <Route exact path="/register" name="Register Page" element={<Register />} /> */}
          <Route exact path="/404" name="Page 404" element={<Page404 />} />
          <Route exact path="/500" name="Page 500" element={<Page500 />} />
          <Route
            path="*"
            name="Home"
            element={shouldShowLogin() ? <Navigate to="/login" replace /> : <DefaultLayout />}
          />
          <Route
            exact
            path="/selectcompany"
            name="Selecionar Empresa"
            element={shouldShowLogin() ? <Navigate to="/login" replace /> : <AdminSelectCompany />}
          />
        </Routes>
      </Suspense>
    </HashRouter>
  )
}

export default App
